import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";

const BootStrapDialogue = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(4),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
}));

const MyDialogue = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    backgroundColor: theme.palette.danger,
  },
}));

export default function DialogModal(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseAndDoAction = () => {
    props.closeAction(props.index);
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Button
        variant={props.variant || "contained"}
        onClick={handleClickOpen}
        color={props.color}
      >
        {props.btnTxt}
      </Button>
      <MyDialogue
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="customized-dialog-title"
          color={props.color}
        >
          {props.title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon color="success" />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>{props.message}</Typography>
        </DialogContent>
        <DialogActions>
          {props.CancelBtnTxt && (
            <Button autoFocus onClick={handleClose} color={"success"}>
              {props.CancelBtnTxt}
            </Button>
          )}
          {props.OkBtnTxt && (
            <Button autoFocus onClick={handleCloseAndDoAction} color={"error"}>
              {props.OkBtnTxt}
            </Button>
          )}
        </DialogActions>
      </MyDialogue>
    </React.Fragment>
  );
}
